import React, {useContext} from 'react';
import Work from "./Work";
import PortfolioContext from "../../contexts/Portfolio";
import "./Portfolio.scss";

const Portfolio = ({isHome = false}) => {

	const {portfolio_works} = useContext(PortfolioContext);

	return (
		<div className="row portfolio-list">
			{portfolio_works
				.filter(work => isHome ? work.wyswietl_na_stronie_glownej : work)
				.filter(work => !work.szkic)
				.map(work => <Work
								key={work.tytul_filmu}
								work={work}
								className="col col-xs-12 col-md-4"/>
				)}
		</div>
	);
};

export default Portfolio;